import { Employer } from '@backrs_ui/common-ui';

import { SEARCH_CATEGORIES } from '@backrs_ui/grow-ui/src/pages/Search/search.filters';
import { SearchCategory } from '@backrs_ui/grow-ui/src/pages/Search/search.types';
import { SearchResult } from '@backrs_ui/grow-ui/src/redux/search/search';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const employerApi = createApi({
  reducerPath: 'employerApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getEmployerBySlug: build.query<Employer, string>({
      query: (slug) => `employers/${slug}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    searchForEmployerResources: build.query<
      SearchResult,
      {
        types?: SearchCategory[];
        sponsor_id?: number;
        employer_id?: number;
        perPage?: number;
        page?: number;
      }
    >({
      query: ({ types, sponsor_id, employer_id, page = 1, perPage = 12 }) => {
        const filter = JSON.stringify({
          q: '', // empty query since we fetch all resources associated with the employer
          ...((types?.length || 0) > 0 && { types }),
          ...(sponsor_id && { sponsor_id }),
          ...(employer_id && { employer_id }),
        });

        const searchParams = new URLSearchParams();

        searchParams.append('filter', filter);

        searchParams.append('page', String(page));
        searchParams.append('perPage', String(perPage));

        return `content-search?${searchParams.toString()}`;
      },
    }),
    searchForEmployerPeople: build.query<
      SearchResult,
      {
        employerName?: string;
        perPage?: number;
        page?: number;
      }
    >({
      query: ({ employerName, page = 1, perPage = 12 }) => {
        const filter = JSON.stringify({
          q: '',
          types: [SEARCH_CATEGORIES.PEOPLE_INTERNAL],
          ...(employerName && { employerName }),
        });

        const searchParams = new URLSearchParams();

        searchParams.append('filter', filter);
        searchParams.append('page', String(page));
        searchParams.append('perPage', String(perPage));

        return `content-search?${searchParams.toString()}`;
      },
    }),
  }),
});

export const {
  useGetEmployerBySlugQuery,
  useSearchForEmployerResourcesQuery,
  useSearchForEmployerPeopleQuery,
  usePrefetch: usePrefetchEmployer,
  util: { resetApiState },
} = employerApi;
